const shows = [
  {
    date: 'September 26, 2026',
    event: 'Private Birthday Event',
    location: ''
  },
  {
    date: 'August 15, 2026',
    event: 'Private BBQ Event',
    location: ''
  },
  {
    date: 'August 26, 2026',
    time: '7:00-8:30 PM',
    event: 'Music in the Park',
    location: 'Rambling River Park, Farmington, MN',
    fbLink: 'https://www.facebook.com/share/1BJBgNaDkt/'
  },
  {
    date: 'July 28, 2026',
    time: '6:00-9:00 PM',
    event: 'Live Music at the Golf Course',
    location: 'The Pub Bar & Grill, Crystal Lake Golf Course, Lakeville, MN',
    fbLink: 'https://www.facebook.com/share/1GB1mLPdji/'
  },
  {
    date: 'June 3, 2026',
    time: '5:00-8:00 PM',
    event: 'Live Music & Pizza Night',
    location: 'Red Barn Farm, Northfield, MN',
    fbLink: 'https://www.facebook.com/share/18N7ocjCoP/'
  },
  {
    date: 'April 18, 2026',
    time: '5:00-10:00 PM',
    event: 'Celebrate Me Week Gala Fundraiser',
    ticketsLink: 'https://www.celebratemeweek.co/event-details/2026-celebrate-me-week-gala?fbclid=IwY2xjawQdgt9leHRuA2FlbQIxMABicmlkETFTRHQ0cFFpb1BJZHdvRVg2c3J0YwZhcHBfaWQQMjIyMDM5MTc4ODIwMDg5MgABHkgjTYfdn9fY8TZAQ-uiq69GR3Z1fn0rR4zIk9i_Gx6durmCn3tIqyJjtIMv_aem_lD-RYLjJQ1rEgoiWZxHFLQ',
    location: 'Sky One Eleven Event Space, Mankato, MN'
  },
  {
    date: 'November 15, 2025',
    event: 'Farmington Dance Parents Night Out',
    location: 'Celts Pub, Farmington, MN'
  },
  {
    date: 'August 5, 2025',
    event: 'Private Event for National Night Out',
    location: 'Lakeville, MN'
  },
  {
    date: 'July 26, 2025',
    event: 'Private BBQ Event',
    location: ''
  }
];

export default shows;